import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DefaultControlValueAccessor } from '@coin/shared/core/util-helpers';
import { CardPadding, CardRounding, V2CardComponent } from '../card/v2-card.component';
import { V2CheckboxComponent } from '../checkbox/v2-checkbox.component';

@Component({
  selector: 'coin-v2-selectable-card',
  templateUrl: './v2-selectable-card.component.html',
  styleUrls: ['./v2-selectable-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [V2CardComponent, V2CheckboxComponent, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => V2SelectableCardComponent),
      multi: true
    }
  ],
  host: {
    '[class]': "`${this.disabled() ? 'disabled' : ''}`"
  }
})
export class V2SelectableCardComponent extends DefaultControlValueAccessor<boolean> {
  padding = input<CardPadding>('medium');
  rounding = input<CardRounding>('medium');

  protected toggleCard(): void {
    if (this.disabled()) return;
    this.value = !this.value;
  }
}
